import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
@NgModule({
    declarations: [
    ],
    imports: [
        BrowserModule,
    ],
    exports: [
    ],
    providers: [],
    bootstrap: []
})
export class ComponentsModule { }
